import { getMegaraxPath } from "@megaron/megarax-uri";
import { Uuid } from "@megaron/uuid";
export const getGroupPath = (id: string) => getMegaraxPath.uri("megarax://iam/groups/id/{id}", { id: Uuid(id) });
export const getNewGroupPath = () => getMegaraxPath.uri("megarax://iam/groups/new");
